module.exports = __webpack_public_path__ + "img/Praxair.11891fc7.jpg";